import { ProductProvider } from '@shopify/hydrogen-react';
import { Product } from '@shopify/hydrogen-react/storefront-api-types';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { orgFromProduct, ProductOrgMetafields } from '../../config/storeConfig';
import { useStoreActions, useStoreState } from '../../store';
import PageShell from '../app/PageShell';
import ProductDetails from './ProductDetails';
import { getProductDetails } from '../../utils/storefront/products/actions';

const ProductPage: React.FC = () => {
  const { product } = useParams();
  const navigate = useNavigate();
  const [productDetails, setProductDetails] = useState<Product | undefined>();
  const setContext = useStoreActions(actions => actions.orgContext.setContext);
  const currentOrgId = useStoreState(state => state.orgContext.orgId);

  useEffect(() => {
    let cancelled = false;
    setProductDetails(undefined);

    getProductDetails(product)
      .then(response => {
        if (cancelled) return;
        if (response) {
          setProductDetails(response);
        } else {
          navigate('/not-found');
        }
      })
      .catch(() => {
        if (!cancelled) navigate('/not-found');
      });

    return () => {
      cancelled = true;
    };
  }, [product, navigate]);

  useEffect(() => {
    if (!productDetails) return;
    const derived = orgFromProduct(productDetails as ProductOrgMetafields);
    if (!derived) {
      navigate('/not-found', { replace: true });
      return;
    }
    if (!currentOrgId) setContext({ orgId: derived });
  }, [productDetails, currentOrgId, setContext, navigate]);

  return (
    <PageShell>
      <div>
        {productDetails && (
          <ProductProvider data={productDetails}>
            <ProductDetails />
          </ProductProvider>
        )}
      </div>
    </PageShell>
  );
};

export default ProductPage;
